<script lang="ts" setup>
import { computed, ref } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';

const props = withDefaults(
  defineProps<{
    inputId?: string;
    modelValue?: string;
    hasError?: boolean;
  }>(),
  {
    inputId: '',
    modelValue: '',
    hasError: false,
  },
);

const emit = defineEmits<{
  'update:modelValue': [password: string];
  keydown: [event: KeyboardEvent];
}>();

const passwordValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

const isPasswordVisible = ref(false);

const togglePasswordVisible = () => {
  isPasswordVisible.value = !isPasswordVisible.value;
};

const keyDown = (event: KeyboardEvent) => {
  emit('keydown', event);
};
</script>

<template>
  <div class="password-input">
    <input
      :id="inputId"
      class="password c-textInput"
      name="password"
      placeholder=""
      :type="!isPasswordVisible ? 'password' : 'text'"
      :class="{ 'c-formInput--error': hasError }"
      v-model="passwordValue"
      @keydown="keyDown"
    />
    <div class="eye-switch">
      <div class="eye-icon" @click="togglePasswordVisible">
        <DgrIcon :name="isPasswordVisible ? 'eye' : 'eye-alt'" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.password-input {
  position: relative;
  .password {
    outline: none;
    padding-right: 48px;
  }
  .eye-switch {
    position: absolute;
    top: 0;
    right: 0;
    .eye-icon {
      padding: 8px;
      cursor: pointer;
    }
  }
}
</style>
